import React, { Fragment, useEffect } from "react";
import { useImmer } from "use-immer";
const YesNoChoice = ({ onChange, initialPayload }) => {
  const [content, setContent] = useImmer(
    initialPayload &&
      initialPayload.question &&
      initialPayload.yes_response &&
      initialPayload.no_response
      ? initialPayload
      : {
          question: "",
          yes_response: "",
          no_response: "",
        }
  );
  useEffect(() => {
    onChange(content);
  }, [content]);
  const handleChangeQuestion = ({ target }) => {
    const question = target.value;
    setContent((draft) => {
      draft.question = question;
    });
  };
  const handleChangeYesResponse = ({ target }) => {
    const yes_response = target.value;
    setContent((draft) => {
      draft.yes_response = yes_response;
    });
  };
  const handleChangeNoResponse = ({ target }) => {
    const no_response = target.value;
    setContent((draft) => {
      draft.no_response = no_response;
    });
  };
  return (
    <Fragment>
      <input
        name="yes_no_choice"
        placeholder={`Input your question`}
        class="form-control form-control-md mb-2"
        autocomplete="off"
        value={content.question}
        onChange={handleChangeQuestion}
      ></input>
      <div className="row-div" style={{ marginBottom: 5 }}>
        <p style={{ flexShrink: 0, marginRight: 5 }}>If Yes</p>
        <input
          name="yes_response"
          class="form-control form-control-md"
          value={content.yes_response}
          onChange={handleChangeYesResponse}
        ></input>
      </div>
      <div className="row-div" style={{ marginBottom: 10 }}>
        <p style={{ flexShrink: 0, marginRight: 10 }}>If No</p>
        <input
          name="no_response"
          class="form-control form-control-md"
          autocomplete="off"
          value={content.no_response}
          onChange={handleChangeNoResponse}
        ></input>
      </div>
    </Fragment>
  );
};

export default YesNoChoice;



// WEBPACK FOOTER //
// ./src/screens/Tasks/components/YesNoChoice.js